module.exports = __webpack_public_path__ + "static/media/kid19.7b9cebb2.png";